export var isAxiosTimeoutError = function (err) {
    if (!(err instanceof Error)) {
        return false;
    }
    return err.message.includes('timeout of');
};
